import { Directive } from '@angular/core';
import { ConstructionMetadata, SimpleEntity } from 'src/app/_types/lead.types';
import { getConstructionTypeEnumLabel } from 'src/app/enums/construction/construction-type.enum';
import { getEntityTypeLabel } from 'src/app/enums/construction/entity-type.enum';
import { getNearestStructureDistanceEnumLabel } from 'src/app/enums/construction/nearest-structure-distance.enum';
import {
  getProjectOwnerTypeLabel,
  ProjectOwnerType,
} from 'src/app/enums/construction/project-owner-type.enum';
import { getTopographyEnumLabel } from 'src/app/enums/construction/topography.enum';
import { getBooleanLabel } from 'src/app/helpers/utils';

import { BaseMetadataComponent } from '../base-metadata.component';

@Directive()
export abstract class ConstructionMetadataComponentAbstract extends BaseMetadataComponent<ConstructionMetadata> {
  getTopographyLabel = getTopographyEnumLabel;

  getNearestStructureDistanceLabel = getNearestStructureDistanceEnumLabel;

  getConstructionEnumTypeLabel = getConstructionTypeEnumLabel;

  getConstructionEntityTypeLabel = getEntityTypeLabel;

  getConstructionProjectOwnerTypeLabel = getProjectOwnerTypeLabel;

  getBooleanLabel = getBooleanLabel;

  displayEntity(entity?: SimpleEntity & { type?: ProjectOwnerType }) {
    return (
      entity &&
      (entity.type ||
        entity.address ||
        entity.email ||
        entity.fullName ||
        entity.phoneNumber)
    );
  }

  displayRiskInfo(metadata: ConstructionMetadata) {
    return (
      metadata &&
      (metadata.totalCost ||
        metadata.nearestStructure ||
        metadata.topography ||
        (metadata.isCivilEngineering !== null &&
          metadata.isCivilEngineering !== undefined) ||
        (metadata.plannedDemolition !== undefined &&
          metadata.plannedDemolition !== null))
    );
  }

  displayInsuranceInfo(metadata: ConstructionMetadata) {
    return (
      metadata &&
      (metadata.constructionWorkInsuranceWanted !== null ||
        metadata.constructionWorkInsuranceWanted !== undefined ||
        (metadata.projectOwnerCivilResponsibility !== null &&
          metadata.projectOwnerCivilResponsibility !== undefined) ||
        (metadata.nearAdjuvant !== null &&
          metadata.nearAdjuvant !== undefined) ||
        (metadata.fireNaturalDisasterInsurance !== null &&
          metadata.fireNaturalDisasterInsurance !== undefined) ||
        (metadata.ownerWithoutInsurance !== null &&
          metadata.ownerWithoutInsurance !== undefined))
    );
  }
}
